import React, { createRef, useEffect, useState } from "react";
import OTPInput from "otp-input-react";
import axios from "axios";
import { DialogTitle, Grid, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "../store/user";
import { useNavigate } from "react-router-dom";
// import { push } from "react-router-dom";

export default function OtpView(props) {
  const [minutes, setMinutes] = useState("");
  const [seconds, setSeconds] = useState("");
  const [otp, setOtp] = useState("");
  const [isOtpWrong, setIsOtpWrong] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [otp_expired_date, setOtp_expired_date] = useState(
    props.otpExpiredDate
  );
  const [regenerateOtp, setRegenerateOtp] = useState(false);
  const [disabledRegenerateOtpBtn, setDisabledRegenerateOtpBtn] =
    useState(true);
  const [isResendNewOtp, setIsResendNewOtp] = useState(false);
  const [disabledBtn, setDisabledBtn] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const diff_minutes = (date2, date1) => {
    var diff = (date2.getTime() - date1.getTime()) / 1000;
    diff /= 60;
    return Math.abs(Math.round(diff));
  };
  const userInfo = useSelector((state) => state.user.user);
  const verifyOTP = async () => {
    setIsOtpWrong(false);
    setErrorMessage("");
    console.log(otp.length);
    const data = {
      otp: otp,
      token: localStorage.getItem("otp_token"),
    };

    await axios
      .post("http://127.0.0.1:3001/api/v1/auth/verify-otp", data)
      .then((response) => {
        localStorage.setItem("user", JSON.stringify(response.data.user));
        localStorage.setItem("token", response.data.token);
        dispatch(setUser(response.data.user));
        console.log("user info is down");
        console.log(userInfo);

        switch (response.data.user.type) {
          case "0":
            window.location = "/sortera-admin";
            break;
          case "1":
            window.location = "/admin";
            break;
          case "2":
            window.location = "/quality-assurance";
            break;
          case "3":
            window.location = "/annotator";
            break;
        }


      })
      .catch((error) => {
        setIsOtpWrong(true);
        setErrorMessage("⚠️ " + error.response.data.message);
      });
  };

  const resendOTP = async () => {
    const data = {
      token: localStorage.getItem("otp_token"),
      email:props.email
    };

    await axios
      .post("http://127.0.0.1:3001/api/v1/auth/regenerate-otp", data)
      .then((response) => {
        setOtp_expired_date(response.data.data.data.expired_at);
        setRegenerateOtp(true);
        localStorage.setItem("otp_token", response.data.data.data.token);
      })
      .catch((error) => {
        setIsOtpWrong(true);
        setErrorMessage("⚠️ " + error.response.data.message);
      });
  };

  useEffect(() => {
    let second = String("59").padStart(2, '0');
    let minutes = diff_minutes(new Date(otp_expired_date), new Date()) - 1;
    setDisabledRegenerateOtpBtn(true);
    let interval = setInterval(() => {
      if (minutes === 0 && second === 0) {
        clearInterval(interval);

        if (!isResendNewOtp) {
          setDisabledRegenerateOtpBtn(false);
          setIsResendNewOtp(true);
        }
      } else {
        if (second == 0) {
          second--;
          minutes--;
          second = 59;
          setSeconds(String(second).padStart(2, '0'));
          setMinutes(minutes);
        } else {
          setMinutes(minutes);
          second--;
          setSeconds(String(second).padStart(2, '0'));
        }

        if (minutes === 3) {
          setDisabledRegenerateOtpBtn(false);
        }

      }
    }, 1000);
  }, [regenerateOtp]);

  return (
    <div className="relative bg-white px-6 pt-10 pb-9 shadow-xl mx-auto w-full max-w-xl rounded-2xl">
      <DialogTitle sx={{ m: 0, p: 2 }}>
        <IconButton
          aria-label="close"
          onClick={props.handelOpenDialog}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <div className="mx-auto flex w-full max-w-md flex-col space-y-12">
        <div className="flex flex-col items-center justify-center text-center space-y-2">
          <div className="font-semibold text-3xl">
            <p>OTP Verification</p>
          </div>
          <div className="flex flex-row text-sm font-medium text-gray-400">
            <p>We have sent a code to your email {props.email}</p>
          </div>
        </div>

        <div className="flex flex-row text-sm font-medium text-gray-700 m-t-5 text-center justify-center">

          {minutes === 0 ? (
            <p>
              {seconds}
            </p>
          ) : (
            <p>
              {minutes} : {seconds}
            </p>
          )}

        </div>

        <div>
          <div className="flex flex-col space-y-16">
            <dl className="flex flex-row items-center justify-between mx-auto w-full max-w-md">
              <OTPInput
                value={otp}
                onChange={(e) => {
                  if (e.length >= 6) {
                    setDisabledBtn(false);
                  } else {
                    setDisabledBtn(true);
                  }
                  setOtp(e);
                }}
                autoFocus
                OTPLength={6}
                otpType="number"
                inputStyles={{
                  borderRadius: "0.75rem",
                  borderWidth: "1px",
                  width: "50px",
                  height: "50px",
                  borderColor: isOtpWrong ? "red" : "black",
                }}
              />
            </dl>
          </div>
        </div>

        <div className=" font-medium text-red-700 text-center justify-center">
          <p>{errorMessage}</p>
        </div>

        <div className="flex flex-col space-y-5">
          <div>
            <button
              className="flex  items-center justify-center text-center w-full  border rounded-xl outline-none py-3 bg-[#212e79] border-none text-white text-sm shadow-sm disabled:bg-[#e8e4e4]"
              onClick={verifyOTP}
              disabled={disabledBtn}
            >
              Verify
            </button>
          </div>

          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
          ></Grid>
          <div className="flex  items-center justify-center text-center  font-medium space-x-1 text-gray-500">
            Didn't receive code?
            <button
              className="  items-center text-[#212e79] disabled:text-gray-400 p-1 "
              onClick={resendOTP}
              disabled={disabledRegenerateOtpBtn}
            >
              Resend
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
